import * as Crypto from 'expo-crypto';
import { supabase } from './supabase';

export type FeedbackFeature = 'cv_create' | 'cv_score' | 'linkedin_audit' | 'cover_letter';
export type FeedbackRating = 'up' | 'down';

export interface FeedbackInput {
  feature: FeedbackFeature;
  // Sérialisation stable du résultat (cf. utils/resultRef) — hashée ici, jamais envoyée en clair.
  resultKey: string;
  rating: FeedbackRating;
  comment?: string;
}

/**
 * Enregistre l'avis de l'utilisateur sur un résultat IA. UPSERT sur (user_id, result_ref) :
 * changer d'avis (pouce bas -> pouce haut) ou ajouter un commentaire met à jour la même ligne.
 * result_ref = SHA-256 de la clé de résultat → aucun contenu de CV/profil n'atteint la base.
 * Donnée de mesure interne : n'est jamais renvoyée à l'API Claude.
 */
export async function submitFeedback(input: FeedbackInput): Promise<void> {
  // getUser() (et non le store) garantit que user_id envoyé == auth.uid() de la session serveur,
  // sinon la policy RLS (user_id = auth.uid()) rejette l'insert.
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) throw new Error('Tu dois être connecté.');

  const resultRef = await Crypto.digestStringAsync(
    Crypto.CryptoDigestAlgorithm.SHA256,
    input.resultKey,
  );

  const { error } = await supabase.from('feedback').upsert(
    {
      user_id: user.id,
      feature: input.feature,
      result_ref: resultRef,
      rating: input.rating,
      comment: input.comment?.trim() || null,
    },
    { onConflict: 'user_id,result_ref' },
  );
  if (error) throw error;
}
